'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prepareChildKeys = require('./prepareChildKeys');

var _prepareChildKeys2 = _interopRequireDefault(_prepareChildKeys);

var _findKey = require('unmutable/lib/findKey');

var _findKey2 = _interopRequireDefault(_findKey);

var _get = require('unmutable/lib/get');

var _get2 = _interopRequireDefault(_get);

var _isIndexed = require('unmutable/lib/util/isIndexed');

var _isIndexed2 = _interopRequireDefault(_isIndexed);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key) {
    return function (parcelData) {
        if (!(0, _isIndexed2.default)(parcelData.value) || typeof key === "number") {
            return key;
        }
        return (0, _pipeWith2.default)(parcelData, (0, _prepareChildKeys2.default)(), (0, _get2.default)('child'), (0, _findKey2.default)(function (_) {
            return _.key === key;
        }));
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/keyOrIndexToProperty.js
// module id = 184
// module chunks = 35783957827783